import { brand } from '@/styles/shared';
interface NoteIconProps {
  width?: number;
  height?: number;
  stroke?: string;
  strokeWidth?: string;
}

const NoteIcon: React.FC<NoteIconProps> = ({
  width = 28,
  height = 28,
  stroke = brand.purpleAccent,
  strokeWidth = "2.66667"
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 2V2C24.2091 2 26 3.79086 26 6L26 8.85714C26 9.30264 26 9.52539 25.8978 9.68801C25.8445 9.77282 25.7728 9.84453 25.688 9.89781C25.5254 9.99999 25.3027 9.99999 24.8572 9.99999L18 9.99999M22 2V2C19.7909 2 18 3.79086 18 6L18 9.99999M22 2L7.33334 2C4.81918 2 3.5621 2 2.78105 2.78105C2 3.5621 2 4.81918 2 7.33334L2 26L6 24.6667L10 26L14 24.6667L18 26L18 9.99999"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path
        d="M7.33325 7.33334L12.6666 7.33334"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M8.66675 12.6667H7.33341"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M7.33325 18L11.3333 18"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
};

export default NoteIcon;
